// "2. Stück" cart hint (MSDEV-93), see snippets/ms-second-piece-cart-hint.liquid.
// Custom element so it re-evaluates whenever the cart drawer/page is re-rendered.
class MsSecondPieceHint extends HTMLElement {
  connectedCallback() {
    // The green confirmation replaces the line's native discount pill (same parent).
    if (this.dataset.state !== 'active') return;
    const native = this.parentElement && this.parentElement.querySelector('[data-ms-2p-native]');
    // Inline style: the lists carry a `flex` utility class that would override [hidden].
    if (native) native.style.display = 'none';
  }
}

if (!customElements.get('ms-second-piece-hint')) {
  customElements.define('ms-second-piece-hint', MsSecondPieceHint);
}
